import React from 'react';
import { Dropdown } from 'antd';
import type { DropdownProps } from 'antd';
import { useOneButtonStore } from '../../../../../store/oneButtonStore';

export type OBDDropdownProps = DropdownProps;

const OBDDropdown: React.FC<OBDDropdownProps> = ({ overlayClassName, ...props }) => {
    const theme = useOneButtonStore((s) => s.theme);
    const mergedOverlayClassName = overlayClassName
        ? `${overlayClassName} obd-select-dropdown obd-theme-${theme}`
        : `obd-select-dropdown obd-theme-${theme}`;

    return <Dropdown {...props} overlayClassName={mergedOverlayClassName} />;
};

export default OBDDropdown;
